export default __webpack_public_path__ + "media/zurb/img/lab/playground/playground-hero-bg-985c0c052708e168a728a00b5e40098a.png";